module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6QcTTsJFGSTei1WIJ0CSSw-77741381873a7ab09163578d5091f064.jpg";